import React from "react";
import "./iptccodecombobox.css";

class IptcCodeComboBox extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            text: "",
            focused: false,
            selectedIndex: -1,
            listStyle: {
                    left: 0,
                    top: 0,
                    width: 470,
                    maxHeight: 800
            }            
        };

        this.containerRef = React.createRef();

        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.selectItem = this.selectItem.bind(this);
    }

    componentDidMount()
    {
        document.addEventListener(
                "mousedown",
                this.handleClickOutside
            );

            window.addEventListener(
                "resize",
                this.updateListPosition
            );

            window.addEventListener(
                "scroll",
                this.updateListPosition,
                true
            );

            this.updateTextFromValue(
                this.props.value
            );

    }

    componentWillUnmount()
    {
        document.removeEventListener(
            "mousedown",
            this.handleClickOutside
        );

        window.removeEventListener(
            "resize",
            this.updateListPosition
        );

        window.removeEventListener(
            "scroll",
            this.updateListPosition,
            true
        );
    }
    componentDidUpdate()
    {
    if (!this.containerRef.current)
        return;

    const items =
        this.containerRef.current.querySelectorAll(
            ".iptc-combobox-item"
        );


}
 componentDidUpdate(prevProps)
{
    if (!this.containerRef.current)
        return;

    const items =
        this.containerRef.current.querySelectorAll(
            ".iptc-combobox-item"
        );


    if ((prevProps.value !== this.props.value) || (prevProps.conceptSet !== this.props.conceptSet))
        {
            this.updateTextFromValue(this.props.value);
        }
 
}


updateListPosition = () =>
{
    if (!this.containerRef.current)
        return;

    const input =
        this.containerRef.current.querySelector(".iptc-combobox-input");

    if (!input)
        return;

    const rect = input.getBoundingClientRect();



    const margin = 5;
    const listWidth = 470;
    const maxListHeight = 800;

    const vw = window.innerWidth;
    const vh = window.innerHeight;

    /*
     * ---------------------------------------------------------
     * POSITION HORIZONTALE
     * ---------------------------------------------------------
     */

    let left;

    // 1. On essaie d'aligner le bord gauche avec l'input
    if (rect.left + listWidth <= vw - margin)
    {
        left = rect.left;
    }
    // 2. Sinon on aligne le bord droit de la liste avec le bord droit
    //    de l'input
    else if (rect.right - listWidth >= margin)
    {
        left = rect.right - listWidth;
    }
    // 3. Sinon on colle simplement la liste dans la fenêtre
    else
    {
        left = vw - listWidth - margin;
    }

    // Sécurité absolue : la liste ne peut jamais sortir horizontalement
    left = Math.max(
        margin,
        Math.min(left, vw - listWidth - margin)
    );


    /*
     * ---------------------------------------------------------
     * POSITION VERTICALE
     * ---------------------------------------------------------
     */

    const spaceBelow = vh - rect.bottom - margin - 50;
    const spaceAbove = rect.top - margin;

    let top;
    let maxHeight;

    // Priorité : dessous
    if (spaceBelow >= 150)
    {
        top = rect.bottom + margin - 110;
        maxHeight = Math.min(maxListHeight, spaceBelow);
    }

    // Sinon au-dessus
    else if (spaceAbove >= 150)
    {
        maxHeight = Math.min(maxListHeight, spaceAbove);

        top = rect.top - maxHeight - margin;
    }

    // Si aucune position ne permet 150px,
    // on prend tout l'espace disponible dessous
    else
    {
        top = rect.bottom + margin;

        maxHeight = Math.max(
            100,
            spaceBelow
        );
    }


    /*
     * ---------------------------------------------------------
     * SÉCURITÉ VERTICALE
     * ---------------------------------------------------------
     */

    if (top < margin)
        top = margin;

    if (top + maxHeight > vh - margin)
    {
        maxHeight = vh - top - margin;
    }

    maxHeight = Math.max(100, maxHeight);


    this.setState({
        listStyle: {
            position: "fixed",
            left: `${left}px`,
            top: `${top}px`,
            width: `${listWidth}px`,
            maxHeight: `${maxHeight}px`,
            boxSizing: "border-box"
        }
    });
};



    updateTextFromValue(value)
    {
        if (!value)
        {
            if (this.state.text !== "")
            {
                this.setState({
                    text: ""
                });
            }

            return;
        }

        const items = this.getItems();

        const item = items.find(
            item => item.iptc_code === value
        );

        if (item)
        {
            const text =
                item.iptc_code + " - " + item.title;

            if (this.state.text !== text)
            {
                this.setState({
                    text: text
                });
            }
        }
        else
        {
            /*
             * Si le code n'existe pas dans le JSON,
             * on affiche quand même sa valeur.
             */
            if (this.state.text !== value)
            {
                this.setState({
                    text: value
                });
            }
        }
    }

    handleClickOutside(event)
    {
        if (
            this.containerRef.current &&
            !this.containerRef.current.contains(event.target)
        )
        {
            this.setState({
                focused: false,
                selectedIndex: -1
            });
        }
    }

    handleFocus()
    {
        this.setState(
            {
                focused: true,
                selectedIndex: -1,
            },
            () =>
            {
                this.updateListPosition();
            }
        );
    }


    handleBlur()
    {
        /*
        * Petit délai pour permettre au onMouseDown
        * de la liste de s'exécuter avant de fermer.
        */
        setTimeout(() =>
        {
            if (
                this.containerRef.current &&
                !this.containerRef.current.contains(
                    document.activeElement
                )
            )
            {
                this.setState({
                    focused: false,
                    selectedIndex: -1
                });
            }
        }, 0);
    }

    handleChange(event)
    {
        this.setState({
            text: event.target.value,
            focused: true,
            selectedIndex: -1
        });
    }



getItems()
{
    const data = this.props.data || {};
    const items = [];

    /*
     * Si true :
     * seuls les éléments possédant un code IPTC
     * sont affichés.
     */
    const mustSetCode = this.props.iptccodemustset === true;

    /*
     * Codes IPTC déjà rencontrés
     */
    const usedCodes = new Set();

    /*
     * Topics sans code déjà rencontrés
     */
    const usedTopicsWithoutCode = new Set();

    /*
     * Normalisation d'une chaîne pour la comparaison
     */
    const normalize = (value) =>
    {
        return String(value || "")
            .replace(/\u00a0/g, " ")
            .trim()
            .replace(/\s+/g, " ")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
    };


    Object.keys(data).forEach((parentTitle) =>
    {
        const parent = data[parentTitle];

        if (!parent)
            return;


        /*
         * ==========================================
         * PARENT
         * ==========================================
         */

        const parentCode = parent.iptc_code || "";

        /*
         * Si un code est obligatoire et que le parent
         * n'en possède pas, on ne l'ajoute pas.
         */
        if (mustSetCode && parentCode === "")
        {
            // On ne fait rien pour le parent.
        }
        else if (parentCode !== "")
        {
            if (!usedCodes.has(parentCode))
            {
                items.push({
                    iptc_code: parentCode,
                    title: parentTitle || "",
                    definition: parent.definition || "",
                    parentTitle: "",
                    isChild: false
                });

                usedCodes.add(parentCode);
            }
        }
        else
        {
            /*
             * Parent sans code :
             * on utilise son titre normalisé.
             */
            const key = normalize(parentTitle);

            if (key !== "" && !usedTopicsWithoutCode.has(key))
            {
                items.push({
                    iptc_code: "",
                    title: parentTitle || "",
                    definition: parent.definition || "",
                    parentTitle: "",
                    isChild: false
                });

                usedTopicsWithoutCode.add(key);
            }
        }


        /*
         * ==========================================
         * CHILDREN
         * ==========================================
         */

        if (Array.isArray(parent.children))
        {
            parent.children.forEach((child) =>
            {
                if (!child)
                    return;

                const code = child.iptc_code || "";
                const topic = child.topic || "";
                const definition = child.definition || "";


                /*
                 * ----------------------------------
                 * Child SANS code IPTC
                 * ----------------------------------
                 */

                if (code === "")
                {
                    /*
                     * Si un code est obligatoire,
                     * on ignore complètement ce child.
                     */
                    if (mustSetCode)
                        return;


                    /*
                     * Sinon, on conserve la logique
                     * actuelle de dédoublonnage.
                     */
                    const topicKey = normalize(topic);

                    if (topicKey === "")
                        return;

                    if (usedTopicsWithoutCode.has(topicKey))
                        return;

                    items.push({
                        iptc_code: "",
                        title: topic,
                        definition: definition,
                        parentTitle: parentTitle || "",
                        isChild: true
                    });

                    usedTopicsWithoutCode.add(topicKey);

                    return;
                }


                /*
                 * ----------------------------------
                 * Child avec code IPTC
                 * ----------------------------------
                 */

                if (usedCodes.has(code))
                    return;

                items.push({
                    iptc_code: code,
                    title: topic,
                    definition: definition,
                    parentTitle: parentTitle || "",
                    isChild: true
                });

                usedCodes.add(code);
            });
        }
    });


    return items;
}
getFilteredItems()
{
    const search = String(this.state.text || "")
        .trim()
        .toLowerCase();

    const items = this.getItems();

    if (search === "")
        return items;

    const contains = (value) =>
    {
        return String(value || "")
            .toLowerCase()
            .includes(search);
    };

    return items.filter((item) =>
    {
        return (
            contains(item.iptc_code) ||
            contains(item.title) ||
            contains(item.definition) ||
            contains(item.parentTitle)
        );
    });
}


    handleKeyDown(event)
    {
        event.stopPropagation();
        
        const items = this.getFilteredItems();

        if (!this.state.focused)
            return;

        if (event.key === "ArrowDown")
        {
            event.preventDefault();

            if (items.length === 0)
                return;

            this.setState((prevState) =>
            {
                let index = prevState.selectedIndex + 1;

                if (index >= items.length)
                    index = 0;

                return {
                    selectedIndex: index
                };
            });
        }
        else if (event.key === "ArrowUp")
        {
            event.preventDefault();

            if (items.length === 0)
                return;

            this.setState((prevState) =>
            {
                let index = prevState.selectedIndex - 1;

                if (index < 0)
                    index = items.length - 1;

                return {
                    selectedIndex: index
                };
            });
        }
        else if (event.key === "Enter")
        {
            event.preventDefault();

            const index = this.state.selectedIndex;

            if (index >= 0 && index < items.length)
            {
                this.selectItem(items[index]);
            }
        }
        else if (event.key === "Escape")
        {
            event.preventDefault();

            this.setState({
                focused: false,
                selectedIndex: -1
            });

            /*
             * On restaure éventuellement la valeur sélectionnée.
             */
            this.updateTextFromValue(this.props.value);
        }
    }

    selectItem(item)
    {
        /*
         * Ce qui est affiché dans l'input :
         *
         * medtop:20001319 - Désinformation
         */
        const text =
            item.iptc_code + " - " + item.title;

        this.setState({
            text: text,
            focused: false,
            selectedIndex: -1
        });

        /*
         * Le parent reçoit uniquement :
         *
         * medtop:20001319
         */
        if (this.props.onChange)
        {
            this.props.onChange(
                item.iptc_code,
                item
            );
        }
    }

renderItem(item, index)
{

    const selected = index === this.state.selectedIndex;

    const itemKey =
        (item.iptc_code || "no-code") +
        "|" +
        (item.title || "") +
        "|" +
        (item.parentTitle || "");


    return (
        <div
            key={itemKey}
            className={
                "iptc-combobox-item" +
                (selected ? " selected" : "") +
                (item.isChild ? " child" : "")
            }
            onMouseDown={(event) => {
                event.preventDefault();
                this.selectItem(item);
            }}
        >
            <div className="iptc-item-title">
                <span className="iptc-code">
                    {item.iptc_code}
                </span>

                <span className="iptc-title">
                    {item.title}
                </span>
            </div>

            {item.isChild && (
                <div className="iptc-parent">
                    {item.parentTitle}
                </div>
            )}

            <div className="iptc-definition">
                {item.definition}
            </div>
        </div>
    );
}

getListMaxHeight()
{
    if (!this.containerRef.current)
        return 400;

    const rect = this.containerRef.current.getBoundingClientRect();

    const spaceBelow =
        window.innerHeight - rect.bottom - 60;

    return Math.max(100, Math.min(400, spaceBelow));
}

render()
    {
        const items = this.getFilteredItems();

        return (
            <div
                ref={this.containerRef}
                className="iptc-combobox"
            >
                <input
                    type="text"
                    value={this.state.text}
                    placeholder={
                        this.props.placeholder ||
                        "Rechercher un code IPTC..."
                    }
                    onBlur = {this.handleBlur}
                    onFocus={this.handleFocus}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyDown}
                    className="iptc-combobox-input"
                    autoComplete="off"
                />

                {this.state.focused && (
                    <div className="iptc-combobox-list" style={this.state.listStyle}>

                        {items.length === 0 && (
                            <div className="iptc-no-result">
                                Aucun résultat
                            </div>
                        )}

                        {items.map((item, index) =>
                            this.renderItem(item, index)
                        )}

                    </div>
                )}
            </div>
        );
    }
}
IptcCodeComboBox.defaultProps ={
    iptccodemustset : true,
}
export default IptcCodeComboBox;
